import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Avatar as MuiAvatar } from '@material-ui/core';
import { isBlank } from 'utils/helperMethods';
import Icon from 'sharedComponents/Icon';
import useStyles from './useStyles';

const Avatar = props => {
  const { className, size, imageUrl, label, type, iconName } = props;
  const classes = useStyles();

  const classNames = clsx(className, classes.container, {
    [classes.sizeL]: size === 'l',
    [classes.sizeM]: size === 'm',
    [classes.sizeS]: size === 's',
    [classes.sizeXs]: size === 'xs',
    [classes.lightBackground]: type === 'icon',
  });

  if (type === 'icon') {
    return (
      <MuiAvatar className={classNames}>
        <Icon name={iconName} width="16" />
      </MuiAvatar>
    );
  }

  if (isBlank(imageUrl) && !isBlank(label)) {
    return <MuiAvatar className={classNames}>{label}</MuiAvatar>;
  }

  return <MuiAvatar className={classNames} src={imageUrl} />;
};

Avatar.propTypes = {
  imageUrl: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['l', 'm', 's', 'xs']),
  type: PropTypes.oneOf(['userpic', 'icon']),
  iconName: PropTypes.string,
  className: PropTypes.string,
};

Avatar.defaultProps = {
  imageUrl: '',
  type: 'userpic',
  iconName: 'document',
  size: 'l',
  label: '',
  className: '',
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/sharedComponents/Avatar/Avatar.js